module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA90lEQVRYR+2UPQrCQBCF34CNnsDKxtpTeAchghgrsVE8iWgjViYIBryDp7C2sfIE2ggj6w+kSHZ31iIWkzLZyft4+94QKn6oYn0ogDqgDqgD/+3AIOXWg9HNYtqGbMwo4VGNcNwN6VI2X+rA/MD16w0nMNpEmO1jWkkg+glPmbEE4dxsoLPo0b1o3noFUcpjMNZgkAQiJ84gTLIhbcQOfAekEBJxo+EVQl8Iqbg3gDnogggRFwHYIELFxQBFEObdJ+3OwIlbUJbc/HW8zpDpiT3twS1wQrwBrFWz7Q+vFlghANh67lpePwG4fu7zXQHUAXVAHajcgSdqHIMh8/M4IgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/icon-down.png
// module id = fAKM
// module chunks = 4